<div class="wrap">
    <slot/>
</div>

<style>
    .wrap {
        color: gray;
        margin:20px auto;
        width: 680px;
        max-width: 100vw;
        border-radius: 10px;
        background-color: white;
        box-shadow: 0 0 5px;
        padding: 10px;
    }
</style>
